import { getConnectionsGuidsByGeomGuidAndSide, postSaveConnectionPiastreBySide } from "./services";

export async function getConnectionsGuidsByGeomGuidAndSideAction({ commit }, payload) {
  try {
    return (await getConnectionsGuidsByGeomGuidAndSide(payload)).data;
  } catch (e) {
    console.log(e);
  }
}

export async function postSaveConnectionPiastreBySideAction({ commit }, payload) {
  try {
    return (await postSaveConnectionPiastreBySide(payload)).data;
  } catch (e) {
    console.log(e);
  }
}
